import propTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const LogoRedemptionPartner = ({width, height, children, ...props}) => (
  <Box
    as="svg"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    {children}
  </Box>
)

LogoRedemptionPartner.defaultProps = {
  width: '200px',
  height: '80px',
}

LogoRedemptionPartner.propTypes = {
  width: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
    propTypes.object,
  ]),
  height: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
    propTypes.object,
  ]),
  viewBox: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
}

export default LogoRedemptionPartner
